import React from 'react'
import Announcements from '../components/Annoucements'
import DataLeave from '../components/DataLeave'
// import CalendarComponent from '../components/CalendarComponent'
// import LeaveData from '../components/LeaveData'
// import WaitingLists from '../components/WaitingLists'
// import ProfileInfo from '../components/ProfileInfo'
// import TaskLeave from '../components/TaskLeave'


const Dashboard = () => {

    return (
        <>
            {/* <div className="container">

                <div className="row">
                    <DataLeave />
                </div>
                <div className="row">
                    <div className="col-sm-12 col-xl-6 col-md-6">
                        <Announcements />
                    </div>
                    <div className="col-sm-12 col-xl-6 col-md-6">
                        <CalendarComponent />
                    </div>
                </div>
            </div> */}

            <div className="container">

                <div className="row">
                    <div className="col-sm-12 col-xl-12 col-md-12">
                        <Announcements />
                    </div>
                </div>
                <div className="row">
                    <DataLeave />
                </div>
            </div>

        </>
    )
}

export default Dashboard;
